import Vue from "vue";

export default {
  namespaced: true,
  state: {
    application: {},
  },
  getters: {
    application: (state) => state.application,
  },
  mutations: {
    SET_APPLICATION(state, payload) {
      state.application = payload
    },
    NEW_APPLICATION(state, payload) {
      state.application = payload
    },
    CHANGE_APPLICATION(state, payload) {
      Object.keys(payload).map(function (key) {
        state.application[key] = payload[key]
      });
    },
    RESET_APPLICATION(state) {
      state.application = {}
    },
  },
  actions: {
    async retrieveApplication({commit}, id) {
      await Vue.axios.get('application/retrieve/' + id + '/')
        .then((response) => {
          commit('SET_APPLICATION', response.data)
        })
    },
    async createApplication({commit}, payload) {
      await Vue.axios.post('application/create/', payload)
        .then((response) => {
          commit('SET_APPLICATION', response.data)
        })
    },
    async updateApplication({commit, state}) {
      await Vue.axios.patch('application/update/' + state.application.id + '/', state.application)
        .then((response) => {
          commit('SET_APPLICATION', response.data)
        })
    },
  }
}
